/* src/components/scroll-navigation/scroll-navigation.component.scss */
:host {
  display: block;
  position: fixed;
  top: 5rem;
  left: 0;
  bottom: 0;
  width: var(--vwui-size-component-nav);
  z-index: var(--vwui--zindex--nav);
  will-change: width;
  transition: width 0.25s ease-in-out 0s;
  box-sizing: border-box;
  padding: 0;
  background: var(--vwui-color-neutral-4);
  overflow: auto;
}
.scroll-navigation__container {
  padding: 2rem var(--padding-x);
}
.scroll-navigation__container .is-groupelement {
  text-transform: uppercase;
}
/*# sourceMappingURL=scroll-navigation.component-NKTWQPLS.css.map */
